<template>
  <div>
    <el-dialog
      :visible.sync="viewDialogVisible"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      class="bullet-detail"
      :title="$lang('运单信息日志')"
    >
      <div class="dialog-content">
        <jms-table
          :option="listOpt"
          :data="tableList"
          :page="page"
          :table-loading="loading"
          @row-del="rowDel"
          @size-change="sizeChange"
          @selection-change="selectionChange"
          @current-change="currentChange"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mixin from '@/mixins/mixin.js'
import { logList } from '@/api/module/customer'

export default {
  name: 'WaybillLog',
  mixins: [mixin],
  data () {
    return {
      viewDialogVisible: false,
      isShowFirst: false,
      COM_HTTP: {
        reqList: logList,
      },
      waybillNo: ''
    }
  },
  computed: {
    listOpt () {
      return {
        border: true,
        menu: false,
        viewBtn: false,
        editBtn: false,
        delBtn: false,
        // rowKey: '$index',
        index: false,
        fixHeight: 90,
        column: [
          {
            label: '运单编号',
            prop: 'waybillCode'
          },
          {
            label: '修改时间',
            prop: 'updated'
          },
          {
            label: '修改内容',
            prop: 'udContent'
          },
          {
            label: '状态',
            prop: 'status'
          },
          {
            label: '原因',
            prop: 'reason'
          },
        ]
      }
    }
  },
  created () {
  },
  methods: {
    showDialog (waybillNo) {
      if (waybillNo) {
        this.waybillNo = waybillNo
        this.searchFun(1)
      }
      this.viewDialogVisible = true
    },
    hideDialog () {
      this.viewDialogVisible = false
    },
    getParams () {
      return {
        pageSize: this.page.size,
        waybillNo: this.waybillNo
      }
    },
  }
}
</script>
<style lang="scss">
.el-dialog__wrapper.bullet-detail {
  .el-dialog {
    margin-bottom: 0 !important;
    .el-dialog__body {
      max-height: 700px;
      overflow: auto;
    }
  }
  .el-dialog__footer {
    padding: 0;
    margin: 10px 20px 20px;
  }
}
</style>
